import { render } from "./RegistrationNameAndDescription.vue?vue&type=template&id=36f6560f&scoped=true"
import script from "./RegistrationNameAndDescription.vue?vue&type=script&lang=js"
export * from "./RegistrationNameAndDescription.vue?vue&type=script&lang=js"

import "@/Common/Styles/registrationSteps.scss?vue&type=style&index=0&id=36f6560f&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f6560f"]])

export default __exports__